import api from "@/api";

import deepClone from "@/utils/deep-clone";
import { numerically } from "@/utils/sort-object";

const state = {
    list: [],
    checkInList: [],
    checkInStats: {},
    checkIn: {},
    checkInDetailList: [], // the list of a checkin
    searchResults: undefined,
    agendaQuestionIdeas: [],
};

const getters = {
    list(state) {
        return ({ scope } = {}) => {
            let list = state?.list ?? [];

            switch (scope) {
                case "admin":
                    return deepClone(
                        list.filter(
                            section => !["defaultSection", "actionItems"].includes(section._id),
                        ),
                    );
                default:
                    return deepClone(list);
            }
        };
    },
};

const actions = {
    getList({ commit }) {
        return api.get("/api/checkins/get/questions").then(res => {
            const list = res?.data;

            if (list && Array.isArray(list)) {
                commit("updateList", {
                    // Sort numerically by `order`
                    list: list.sort(numerically("order")),
                });
            }
        });
    },
    update({ dispatch }, { payload: { data } }) {
        return api.post("/api/checkins/update/questions", data).then(() => {
            return dispatch({ type: "getList" });
        });
    },
    updateOrder({ dispatch }, { payload: { data } }) {
        return api.post("/api/skills/update/order", data).then(() => {
            return dispatch({ type: "getList" });
        });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
